// src/components/FollowButton.jsx - CONTEXT VERSION (no database spam!)
import React, { useState } from 'react';
import { UserPlus, UserCheck } from 'lucide-react';
import { useFollows } from '../contexts/FollowsContext';

export default function FollowButton({ targetUserId, targetUsername }) {
  const { isFollowing, followUser, unfollowUser, loading, currentUserId } = useFollows();
  const [actionLoading, setActionLoading] = useState(false);

  // Don't show button for yourself or invalid data
  if (!currentUserId || !targetUserId || currentUserId === targetUserId) {
    return null;
  }

  // Check if following (instant, from context!)
  const following = isFollowing(targetUserId);

  async function handleFollow() {
    if (actionLoading) return;
    
    setActionLoading(true);
    try {
      if (following) {
        await unfollowUser(targetUserId);
      } else {
        await followUser(targetUserId);
      }
    } finally {
      setActionLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="h-9 w-24 bg-slate-700 animate-pulse rounded-lg" />
    );
  }

  return (
    <button
      onClick={handleFollow}
      disabled={actionLoading}
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg font-semibold text-sm transition-all ${
        following
          ? 'bg-slate-700 hover:bg-slate-600 text-slate-200'
          : 'bg-purple-600 hover:bg-purple-500 text-white'
      } disabled:opacity-60 disabled:cursor-not-allowed`}
      title={following ? `Unfollow ${targetUsername}` : `Follow ${targetUsername}`}
    >
      {actionLoading ? (
        <>
          <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          <span>{following ? 'Unfollowing...' : 'Following...'}</span>
        </>
      ) : following ? (
        <>
          <UserCheck className="w-4 h-4" />
          <span>Following</span>
        </>
      ) : (
        <>
          <UserPlus className="w-4 h-4" />
          <span>Follow</span>
        </>
      )}
    </button>
  );
}